// node modules
import React from 'react';

// app modules: components
import AlacarteCheckout from 'components/AlacarteCheckout';
import Backdrop from 'components/Backdrop';
import Layout from 'components/Layout';
import Signup from 'components/Signup';
import HeadContent from 'components/HeadContent';

async function action({ pathname, store }, params) {
  const { user, dimensions, paywall } = store.getState();
  const { backdrop, logo, logoAlt, partner, signupHeading, signupMessage } = paywall;

  let content;
  if (user.logged_in) {
    content = <AlacarteCheckout isbn={params.id} />;
  } else {
    content = (
      <Signup
        logo={logo}
        logoAlt={logoAlt}
        message={signupMessage || 'Join ckbk to complete your purchase'}
        heading={signupHeading}
        partner={partner}
        returnTo={pathname}
      />
    );
  }
  return {
    chunks: ['alacarte-purchase'],
    component: (
      <Layout
        type="full"
        withLeaderboardAd={false}
        withFooterLeaderboardAd={false}
        overlayPromoBanner={dimensions.displayType !== 'mobile'}
      >
        <HeadContent
          contents={{
            title: 'à la carte checkout',
          }}
        />
        <Backdrop maxWidth="md" filename={backdrop} partner={partner}>
          {content}
        </Backdrop>
      </Layout>
    ),
  };
}

export default action;
